<script context="module" lang="ts">
	import BlockButton from '$lib/components/base/block-button.svelte';
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';

	import infoEmpty from 'iconoir/icons/info-circle.svg';
</script>

<MetaTags
	title="Time Table"
	desc="Our holiday & term time tables are a quick guide to which classes are available."
/>

<Wrapper title="Time Table" transparent>
	<div class="pt-8" />
	<div class="m-auto max-w-2xl rounded-md bg-white p-4 drop-shadow">
		<h2 class="text-2xl text-gray-900 dark:text-gray-50">Select your location</h2>
		<p class="text-gray-900 dark:text-gray-50">
			Choose the location you would like to view classes for:
		</p>
		<div class="my-4 grid grid-cols-1 gap-y-2">
			<BlockButton url="https://app.iclasspro.com/portal/activegymnastics/classes?location=1"
				>O'Connor</BlockButton
			>
			<BlockButton url="https://app.iclasspro.com/portal/activegymnastics/classes?location=2"
				>Jandakot</BlockButton
			>
		</div>
		<p class="text-gray-700 dark:text-gray-300">
			Please note, if you have an account with us, your browser may automically default to your
			previously selected location even if you click a different location above. Please use the 'Map
			Marker' icon in the top right of the portal to change your location.
		</p>
	</div>
</Wrapper>
